import { useQuery } from 'react-query'
import { fetchPayoutPractitioners, PayoutPractitioner } from '../../api/salaryCalculation'

const useGetPayoutPractitioners = (showDeprecated: boolean) => {
  return useQuery<PayoutPractitioner[]>(
    ['salary-calculation-practitioners', showDeprecated],
    () => fetchPayoutPractitioners(showDeprecated),
    {
      refetchOnWindowFocus: false,
    }
  )
}

export default useGetPayoutPractitioners
